const main_config_store = {
    subscribers:{},
    data:{
        hours:localStorage.getItem('sibh_raining_now_hours') || 24,
        date: undefined,
        type: 'plu',
        hide_all_markers: false,
        show_zeros: false,
        additional_layers: {
            landslide: {show: false},
            lightning: {show: false},
            radar: {show: false}
        }
    },
    getDate(){
        return this.data.date
    },
    setAdditionalLayerOptions(layer_title, options){
        this.data.additional_layers[layer_title] = options
        this.publish('SET_ADDITIONAL_LAYER_OPTION', {layer: layer_title, options:options})
    },
    getAdditionalLayerOptions(layer_title, options){
        return this.data.additional_layers[layer_title]
    },
    setDate(date){
        this.data.date = date
        this.publish('DATE_UPDATE', date)
        this.publish('PERIOD_UPDATE', {date:this.date, hours:this.hours})
    },
    setType(type){
        this.data.type = type
        this.publish('TYPE_UPDATE', type)
    },
    setOption(option,value){
        this.data[option] = value
        this.publish('SET_OPTION', {option:option, value:value})
    },
    setOptions(options){
        options.forEach(option=>{
            this.data[option[0]] = option[1]
        })
        this.publish('SET_OPTIONS', {options:options})
    },
    getOption(option){
        return this.data[option]
    },
    getType(){
        return this.data.type
    },
    getHours(){
        return this.data.hours
    },
    setHours(hours){
        this.data.hours = hours
        this.publish('HOURS_UPDATE', hours)
        this.publish('PERIOD_UPDATE', {date:this.date, hours:this.hours})
    },
    pluLoad(){
        this.publish('PLU_LOAD')
    },
    measurementsLoad(){
        this.publish('MEASUREMENTS_LOAD')
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default main_config_store